var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.07724,
    y: 49.1611,
    width: 6,
    height: 30,
    rx: 3,
    transform: "rotate(13.6451 7.07724 49.1611)",
    className: "fill-accents-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.07724,
    y: 49.1611,
    width: 6,
    height: 30,
    rx: 3,
    transform: "rotate(13.6451 7.07724 49.1611)",
    className: "stroke-accents-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.0772,
    y: 49.1611,
    width: 6,
    height: 30,
    rx: 3,
    transform: "rotate(13.6451 89.0772 49.1611)",
    className: "fill-accents-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.0772,
    y: 49.1611,
    width: 6,
    height: 30,
    rx: 3,
    transform: "rotate(13.6451 89.0772 49.1611)",
    className: "stroke-accents-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 20.2051,
    width: 8,
    height: 60.7371,
    rx: 4,
    transform: "rotate(-16 22 20.2051)",
    className: "fill-accents-8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.7422,
    y: 18,
    width: 8,
    height: 60.74,
    rx: 4,
    transform: "rotate(16 67.7422 18)",
    className: "fill-success"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3d4973fd.svg";
export { ForwardRef as ReactComponent };